/**
 * Textura de camuflagem, em SVG, sem imagem externa.
 *
 * Manchas CHAPADAS, não gradiente — e é um encadeamento de três filtros que faz
 * isso sair certo:
 *
 *  1. `feTurbulence` com `fractalNoise` gera a forma orgânica. `baseFrequency`
 *     controla o tamanho da mancha: menor = mancha maior.
 *  2. `feColorMatrix` copia o canal VERMELHO para os três canais, deixando o
 *     ruído em tom único.
 *  3. `feComponentTransfer` com `type="discrete"` corta esse tom em cinco
 *     patamares.
 *
 * O passo 2 é o que importa: como os três canais leem a MESMA entrada, os cinco
 * patamares caem exatamente nas cinco cores da paleta. Se cada canal lesse seu
 * próprio ruído, sairiam combinações aleatórias no lugar dela.
 *
 * `color-interpolation-filters="sRGB"` é OBRIGATÓRIO — no padrão (`linearRGB`)
 * os hexadecimais chegam claros e dessaturados.
 *
 * Paleta: #0d160a · #141a12 · #172417 · #26351f · #34442b
 */

/** Os dois filtros. Monta uma vez, no topo da árvore. */
export function DefinicoesCamuflagem() {
  return (
    <svg width="0" height="0" style={{ position: 'absolute' }} aria-hidden="true">
      {/* Fundo da página: manchas grandes e discretas */}
      <filter id="camuflagem" colorInterpolationFilters="sRGB">
        <feTurbulence type="fractalNoise" baseFrequency="0.0032" numOctaves={3} seed={11} />
        <feColorMatrix values="1 0 0 0 0  1 0 0 0 0  1 0 0 0 0  0 0 0 0 1" />
        <feComponentTransfer>
          {/*            #0d160a #141a12 #172417 #26351f #34442b */}
          <feFuncR type="discrete" tableValues="0.051 0.078 0.090 0.149 0.204" />
          <feFuncG type="discrete" tableValues="0.086 0.102 0.141 0.208 0.267" />
          <feFuncB type="discrete" tableValues="0.039 0.071 0.090 0.122 0.169" />
        </feComponentTransfer>
      </filter>

      {/* Header: mesma paleta, mancha menor e presença maior */}
      <filter id="camuflagemHeader" colorInterpolationFilters="sRGB">
        <feTurbulence type="fractalNoise" baseFrequency="0.0075" numOctaves={4} seed={4} />
        <feColorMatrix values="1 0 0 0 0  1 0 0 0 0  1 0 0 0 0  0 0 0 0 1" />
        <feComponentTransfer>
          <feFuncR type="discrete" tableValues="0.051 0.090 0.149 0.204 0.235" />
          <feFuncG type="discrete" tableValues="0.086 0.141 0.208 0.267 0.310" />
          <feFuncB type="discrete" tableValues="0.039 0.090 0.122 0.169 0.196" />
        </feComponentTransfer>
      </filter>
    </svg>
  )
}

/** Camuflagem do fundo da página: fica atrás de tudo e nunca entra em card. */
export function FundoCamuflado() {
  return (
    <svg className="camuflado-fundo" preserveAspectRatio="none" aria-hidden="true">
      <rect width="100%" height="100%" filter="url(#camuflagem)" />
    </svg>
  )
}

/** Camuflagem do header — mais intensa que a do fundo, de propósito. */
export function HeaderCamuflado() {
  return (
    <svg className="camuflado" preserveAspectRatio="none" aria-hidden="true">
      <rect width="100%" height="100%" filter="url(#camuflagemHeader)" />
    </svg>
  )
}

/** O alvo do cabeçalho. */
export function Alvo() {
  return (
    <svg className="alvo" viewBox="0 0 40 40" aria-hidden="true">
      <g fill="none" stroke="#f2f3ec" strokeWidth="2.4">
        <circle cx="20" cy="20" r="12" />
        <circle cx="20" cy="20" r="6.5" />
        <path d="M20 1v8M20 31v8M1 20h8M31 20h8" />
      </g>
    </svg>
  )
}
